import React from 'react';
import ReactGA from 'react-ga';
import './../../style/Article.css';


class Article extends React.Component {
    handleClick(key) {
        var value = "";
        switch (key) {
            case 1:
                value = "brunch01";
                break;

            case 2:
                value = "brunch02";
                break;

            case 3:
                value = "brunch03"
                break;
        }
        ReactGA.event({
            category: 'WEB',
            action: value,
        });
    }

    constructor(props) {
        super(props);
        this.state = {
            aritcles: [
                {id:1, title:"기획자와 개발자가 만나면", img: "cardTop img03",
                description:"side project: 멍카", 
                content:"시작은 장난스러웠다. 2017년 크리스마스를 한 달여 앞두고 어느 연인처럼 무얼 할까 고민했고, '우리 크리스마스 연휴에 같이 앱하나 만들어볼까?' 무심코 던진 말이 실행으로 옮겨졌다. ",
                    href:"https://brunch.co.kr/magazine/naplab"
                },
                {id:2, title:"기획자와 개발자가 만나면", img: "cardTop img02",
                    description:"side project: 멍카", 
                    content:"시작은 장난스러웠다. 2017년 크리스마스를 한 달여 앞두고 어느 연인처럼 무얼 할까 고민했고, '우리 크리스마스 연휴에 같이 앱하나 만들어볼까?' 무심코 던진 말이 실행으로 옮겨졌다. ",
                    href:"https://brunch.co.kr/@go-rani/2"
                },
                {id:3, title:"하루의 20%는 사이드 프로젝트", img: "cardTop img01",
                    description:"from NAPLAP", 
                    content:"'하루의 20퍼센트는 사이드 프로젝트'는 구글의 '20% Time'에서 영감 받았다. 퇴근 후나 주말에 자신이 하고 싶은 일을 사이드 프로젝트로 풀어보자 라는 뜻에서 시작하게 되었다.",
                    href:"https://brunch.co.kr/@go-rani/3"
                },
            ]
        }
    }


    render() {
        return (
            <div className="section-article">
                <div className="article-title">
                    <div className="title01"><h1>W</h1></div>
                    <div className="title02">
                        <h2>E ARE CREATIVE MINDS WITH A PASSION TO SIDE PROJECT</h2>
                        <p>Not all of them are good ideas, but we should make a good idea</p>
                    </div>
                </div>
                <div className="article-card">
                    {this.state.aritcles.map((article, i)=>
                    <div className="card" key={article.id}>
                        <a className="card_link" target="_blank" onClick={()=>{this.handleClick(article.id)}} href={article.href}>
                            <div className={article.img}></div>
                            <div className="cardBottom">
                                <div className="cardText">
                                    <h3 className="cardTitle">{article.title}</h3>
                                    <h4 className="cardInfo">{article.description}</h4>
                                    <div className="cardHoverText">
                                        <p>{article.content}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                    )}
                </div>
            </div>
        )
    }
}

export default Article;


// WEBPACK FOOTER //
// ./src/components/container/Article.js